$ = require 'jquery'
pluginChromeTemplate = require 'views/templates/plugin_chrome'
PluginChromeView = require 'views/plugin/plugin-chrome-view'

module.exports = class PluginBoardBarView extends PluginChromeView
  initialize: ({ @content }) ->
    @retain(@content)

  className: 'plugin-board-bar'

  events: ->
    'click a[data-index].plugin-chrome-header-action': (e) ->
      index = parseInt($(e.currentTarget).attr('data-index'), 10)
      action = @content.actions[index]
      action?.callback?({ el: e.currentTarget })
    'click .js-close-plugin-chrome': (e) ->
      @close()



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-board-bar-view.coffee